import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import { Link, Navigate, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CCollapse, CLink } from "@coreui/react";
import {
  Dashboard,
  settings,
  Product,
  Users1,
  Vehicle,
  Wrench,
  calendar,
  Employee,
  Suppliers,
  Home,
  Sales1,
  GiftCard,
  Email,
  Receiving,
  Expense,
  Places,
} from "../../../common/imagePath";
import { checkUserPermission } from "../../../common/UserPermission";
import loadingimage from "../../../assets/img/loading-svg.svg";
import ReportListData from "./ReportListData";
const ReportList = (props) => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const [report, setReport] = useState(0);
  const [cursor, setcursor] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [ShowLoading, setShowLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [reportData, setReportData] = useState([]);
  console.log("reportData789", reportData);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.reportsBaseUrl}/reports/Findreport?inputvalue=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              setSuggestions(data);
              setShowLoading(false);

              // setSuggestions([]);
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  useEffect(() => {
    // Fetch data from an API
       const fetchReportData = async () => {
        axios
          .get(
            `${config.reportsBaseUrl}/reports/gettabledata`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
             const data = response.data.ResponseData?.[0] || [];
setReportData(data);
              console.log("get table data", data);

              // setSuggestions([]);
            }
          })
          .catch((error) => {});
    };

    fetchReportData();
  }, []);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setShowLoading(true);
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const [activeIndices, setActiveIndices] = useState([0, 1, 2]);

  const toggleAccordion = (index) => {
    setActiveIndices(
      (prevIndices) =>
        prevIndices.includes(index)
          ? prevIndices.filter((i) => i !== index) // Remove index if already present
          : [...prevIndices, index] // Add index if not present
    );
  };

 <Sidebar />


  return (
<>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <ReportListData/>
          </div>
        </div>
</>
  );
};

export default ReportList;
